import React from "react";
import PropTypes from "prop-types";
import {Chip} from "@mui/material";
import {makeStyles} from "tss-react/mui";
import {findWhere} from "underscore";

export const useMultiStateChipStyles = makeStyles()(
  (theme, {matchingState}) => ({
    multiStateChip: {
      backgroundColor:
        matchingState?.backgroundColor ?? theme.palette.chip.background,
      color: matchingState?.color ?? theme.palette.chip.foreground,
    },
  }),
);

const MultiStateChip = ({value, states, size = "small"}) => {
  const matchingState =
    findWhere(states, {value: value}) ?? findWhere(states, {default: true});
  if (!matchingState) {
    return null;
  }
  const {classes} = useMultiStateChipStyles({matchingState});
  return (
    <Chip
      label={matchingState.display}
      className={classes.multiStateChip}
      size={size}
    />
  );
};

MultiStateChip.propTypes = {
  value: PropTypes.any,
  states: PropTypes.array.isRequired,
  size: PropTypes.string,
};

export default MultiStateChip;
